import * as React from 'react';
import styled from 'styled-components';
import stateSettings from '@state/settings';
import H1 from '../../components/H1';
import FontSizeRow from '@src/editor/Settings/Fonts/FontSizeRow';
const Wrapper = styled.div `
  padding: 24px;
  overflow: scroll;
  flex: 1;
  max-height: 100vh;
`;
const FontRow = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const FontsPage = () => (React.createElement(Wrapper, null,
    React.createElement(H1, null, "Fonts"),
    stateSettings.fonts.map((font) => (React.createElement("div", { key: font.id },
        React.createElement("h2", null, font.fontFamily),
        React.createElement(FontRow, null,
            React.createElement(FontSizeRow, { font: font, fontSizeName: "XS" }),
            React.createElement(FontSizeRow, { font: font, fontSizeName: "S" }),
            React.createElement(FontSizeRow, { font: font, fontSizeName: "M" }),
            React.createElement(FontSizeRow, { font: font, fontSizeName: "L" }),
            React.createElement(FontSizeRow, { font: font, fontSizeName: "XL" })))))));
export default FontsPage;
